<div class="wrapper">
  <div class="content">
    <mat-card>
      <mat-card-header>
        <mat-card-header></mat-card-header>
        <mat-icon svgIcon="close"
          class="close-x"
        (click)="removeComponent()"></mat-icon>
      </mat-card-header>
      @if (!SMASOConfig) {
        <div>
          <mat-spinner color="accent"></mat-spinner>
        </div>
      }
      @if (SMASOConfig) {
        <mat-card-content>
          <h3>
            <span class="new">{{'i18n.additionalInfoItemLayers.smartSorted.new' | translate }}</span>
            {{SMASOConfig.name}}
          </h3>
          <video [autoplay]="'autoplay'"
            [muted]="'muted'"
            controls
            playsinline
            loop>
            <source src="https://storage.googleapis.com/puzzleyou-misc/productdesigner/smart-sorted-small.mp4"
              type="video/mp4">
            </video>
            <ul>
              @for (detail of SMASOConfig.details; track detail) {
                <li
                  [innerHTML]="detail.value">
              </li>
            }
          </ul>
          <p>
            <price-display [price]="SMASOConfig.price"
              [showPriceLabel]="'showPriceDisplay'"
              [quantity]="1">
            </price-display>
          </p>
        </mat-card-content>
      }
      <mat-card-actions>
        <button mat-raised-button
          size="small"
          (click)="removeComponent()"
          >
          {{'i18n.button.noChanges' | translate }}
        </button>
        <button mat-raised-button
          color="primary"
          size="small"
          (click)="changeProduct()"
          >
          {{'i18n.button.chooseSmartSorted' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
